import { combineReducers } from 'redux';
import { isContentChanged, isGfCampaignLoaded } from './actions';

export const dyReducers = combineReducers({
  isContentChanged,
  isGfCampaignLoaded,
});
